import { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import AdminSections from "./AdminSections";
import ProspectsService from "../../services/ProspectsService"
import { LuFileText, LuUpload, LuUserPlus, LuFileChartColumn, LuList } from "react-icons/lu";


export default function AdminContainer() {
    const [isOpen, setIsOpen] = useState(true);
    const [campaigns, setCampaigns] = useState([])
    const adminMenu = [
        { id: "metricas", name: "Metricas", icon: <LuFileText /> },
        { id: "parametros", name: "Parametros", icon: <LuList /> },
        { id: "cargarBase", name: "Cargar Base", icon: <LuUpload /> },
        { id: "asignar", name: "Asignar Prospectos", icon: <LuUserPlus /> },
        { id: "reportes", name: "Reportes", icon: <LuFileChartColumn /> },
    ];
    const [activeSection, setActiveSection] = useState(adminMenu[0].id);

    useEffect(() => {
        //cargamos cuando se requiera en la seccion nomas
        if (activeSection === "parametros" || activeSection === "asignar") {
            getCampaingns();
        }
        if (activeSection === "asignar"){
            console.log("etrnamos aqui")
            getSubsidiary();
        }
    }, [activeSection]);

    const getCampaingns = async () => {
        try {
            const response = await ProspectsService.getCampaingns();
            console.log('campaigns', response.result) //funcioanaaaaaaaaaaa
            setCampaigns(response.result); 
        } catch (error) {
            console.error(error);
        }
    };

    const getSubsidiary = async () =>{
        try {
            const response = await ProspectsService.getSubsidiary();
            console.log('sucursales', response.result)
            setCampaigns(response.result)
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div className="flex h-full">
            <Sidebar
                items={adminMenu}
                active={activeSection}
                onSelect={setActiveSection}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
            />

            {/*lo que deberia de renderizar */}
            <div className="flex-1 p-4">
                <AdminSections 
                    activeSection={activeSection}
                    campaigns={campaigns} 
                />
            </div>
        </div>
    )

}
